import {
  Avatar,
  AvatarGroup,
  AvatarProps,
  useColorModeValue,
} from '@cardboard-ui/react';
import { UserAvatar } from 'components/UserAvatar';
import React from 'react';
import { graphql, useFragment } from 'utils/graphClient';
import { VaultAvatar_vault$key } from './__generated__/VaultAvatar_vault.graphql';

const fragment = graphql`
  fragment VaultAvatar_vault on Vault {
    id
    name
    members {
      id
      ...UserAvatar_member
    }
    thumbnail {
      url
    }
  }
`;

interface VaultAvatarProps extends AvatarProps {
  vault: VaultAvatar_vault$key;
}

export const VaultAvatar = ({ vault, ...props }: VaultAvatarProps) => {
  const { name, members, thumbnail } = useFragment(fragment, vault);
  const bg = useColorModeValue('gray.100', 'gray.800');

  if (thumbnail?.url) {
    return <Avatar name={name} src={thumbnail.url} bg={bg} {...props} />;
  }

  if (members.length === 1) {
    return <UserAvatar member={members[0]} {...props} />;
  }
  return (
    <AvatarGroup size={props.size || 'md'} max={2}>
      {members.map((m) => (
        <UserAvatar key={m.id} member={m} {...props} />
      ))}
    </AvatarGroup>
  );
};
